/**
 * MIRADA — Experiencia NFC editorial para Albino.
 * 
 * Estados de lectura:
 * - "base": experiencia estándar con animaciones
 * - "otra-forma": más contraste, más aire, sin animaciones (elegido por usuario)
 * - "adaptada": preferencias de sistema detectadas (automático)
 *
 * La detección de preferencias del sistema tiene prioridad.
 * El "umbral" (punto de entrada manual) solo aparece si no hay preferencias detectadas.
 */
(function () {
  'use strict';

  var root = document.getElementById('mirada-page-root');
  var audioPlayer = document.getElementById('mirada-audio-player');
  var audioEnabled = false;
  var otraForma = false;

  /** Orden narrativo: índice → clave data-audio-* → elemento que dispara el clip */
  var NARRATIVE_ORDER = [
    { key: 'intro', elId: 'mirada-hero' },
    { key: 'product', elId: 'product-info' },
    { key: 'nutrition', elId: 'label-info' },
    { key: 'discover', elId: 'discover-wine' },
    { key: 'learn_intro', elId: 'learn-intro' },
    { key: 'step_1', elId: 'step-1' },
    { key: 'step_2', elId: 'step-2' },
    { key: 'step_3', elId: 'step-3' },
    { key: 'step_4', elId: 'step-4' },
    { key: 'outro', elId: 'miradas-form' }
  ];

  var playedKeys = {};
  var userPausedScroll = false;
  var scrollTickScheduled = false;

  /** Detecta preferencias de accesibilidad del sistema */
  function detectSystemPreferences() {
    var prefs = {
      reducedMotion: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      highContrast: window.matchMedia && window.matchMedia('(prefers-contrast: more)').matches,
      largeText: parseFloat(getComputedStyle(document.documentElement).fontSize) >= 18
    };
    return prefs.reducedMotion || prefs.highContrast || prefs.largeText;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** Aplica el estado "otra forma" de lectura */
  function setOtraForma(on, fromSystem) {
    otraForma = !!on;
    
    if (fromSystem) {
      document.body.classList.add('forma-adaptada');
      document.body.classList.add('forma-otra');
    } else {
      document.body.classList.remove('forma-adaptada');
      document.body.classList.toggle('forma-otra', otraForma);
    }

    if (otraForma && !fromSystem) {
      try {
        sessionStorage.setItem('albino-forma', 'otra');
      } catch (e) {}
    }

    if (otraForma) {
      setAudioEnabled(false);
    }
  }

  /** Inicializa el umbral (punto de entrada sutil) */
  function initUmbral() {
    var hasSystemPrefs = detectSystemPreferences();
    
    if (hasSystemPrefs) {
      setOtraForma(true, true);
      return;
    }

    try {
      var stored = sessionStorage.getItem('albino-forma');
      if (stored === 'otra') {
        setOtraForma(true, false);
        return;
      }
    } catch (e) {}

    var btnUmbral = document.getElementById('btn-umbral');
    if (btnUmbral) {
      btnUmbral.addEventListener('click', function () {
        setOtraForma(true, false);
        if (navigator.vibrate) navigator.vibrate(30);
      });
    }
  }

  function updatePlaybackDock() {
    var btnPlay = document.getElementById('btn-audio-play-pause');
    var btnMute = document.getElementById('btn-audio-mute');
    if (!audioPlayer || !btnPlay || !btnMute) return;
    var playing = !audioPlayer.paused && !audioPlayer.ended;
    btnPlay.textContent = playing ? 'Pausar' : 'Reanudar';
    btnPlay.setAttribute('aria-pressed', String(playing));
    btnPlay.setAttribute('aria-label', playing ? 'Pausar narración' : 'Reanudar narración');
    var muted = audioPlayer.muted;
    btnMute.textContent = muted ? 'Sonido' : 'Silenciar';
    btnMute.setAttribute('aria-pressed', String(muted));
    btnMute.setAttribute('aria-label', muted ? 'Activar sonido' : 'Silenciar');
  }

  function initPlaybackDock() {
    var btnPlay = document.getElementById('btn-audio-play-pause');
    var btnMute = document.getElementById('btn-audio-mute');
    if (!audioPlayer || !btnPlay || !btnMute) return;
    btnPlay.addEventListener('click', function () {
      if (!audioEnabled || otraForma) return;
      if (audioPlayer.paused || audioPlayer.ended) {
        userPausedScroll = false;
        audioPlayer.play().catch(function () {});
      } else {
        userPausedScroll = true;
        audioPlayer.pause();
      }
      updatePlaybackDock();
    });
    btnMute.addEventListener('click', function () {
      if (!audioEnabled || otraForma) return;
      audioPlayer.muted = !audioPlayer.muted;
      updatePlaybackDock();
    });
    ['play', 'pause', 'ended', 'volumechange'].forEach(function (ev) {
      audioPlayer.addEventListener(ev, updatePlaybackDock);
    });
  }

  function syncAudioIdleBar() {
    var idle = document.getElementById('mirada-audio-idle');
    if (!idle) return;
    idle.hidden = otraForma || audioEnabled;
  }

  function resetNarrationState() {
    playedKeys = {};
    userPausedScroll = false;
  }

  function setAudioEnabled(on) {
    if (otraForma) on = false;
    audioEnabled = !!on;
    var status = document.getElementById('audio-status');
    var band = document.getElementById('mirada-audio-band');
    document.querySelectorAll('.js-audio-toggle').forEach(function (btnToggle) {
      btnToggle.hidden = !!otraForma;
      btnToggle.setAttribute('aria-pressed', String(audioEnabled));
      btnToggle.setAttribute('aria-label', audioEnabled ? 'Desactivar audio' : 'Activar experiencia sonora');
      if (btnToggle.id === 'btn-audio-toggle') {
        btnToggle.textContent = audioEnabled ? 'Desactivar audio' : 'Activar experiencia sonora';
      } else {
        btnToggle.textContent = audioEnabled ? 'Desactivar' : 'Activar sonido';
      }
    });
    if (status) status.hidden = !audioEnabled;
    if (band) {
      band.hidden = !audioEnabled;
      band.classList.toggle('mirada-audio-band-visible', audioEnabled);
    }
    syncAudioIdleBar();
    if (!audioEnabled && audioPlayer) {
      audioPlayer.pause();
      resetNarrationState();
    }
    updatePlaybackDock();
    if (audioEnabled && navigator.vibrate) navigator.vibrate(50);
  }

  function getAudioUrl(key) {
    if (!root) return null;
    var attr = 'data-audio-' + key.replace(/_/g, '-');
    var v = root.getAttribute(attr);
    return v && v.trim() ? v.trim() : null;
  }

  function playAudio(url) {
    if (!url || !audioPlayer) return Promise.reject(new Error('no audio'));
    audioPlayer.src = url;
    return audioPlayer.play().then(updatePlaybackDock).catch(function (err) {
      updatePlaybackDock();
      throw err;
    });
  }

  function isLabelInfoHidden() {
    var lab = document.getElementById('label-info');
    return !lab || lab.hidden;
  }

  /** Cumple prerrequisitos: pistas anteriores reproducidas o omitidas (sin URL / nutrición sin abrir etiqueta). */
  function prerequisitesMetCueIndex(i) {
    for (var j = 0; j < i; j++) {
      var k = NARRATIVE_ORDER[j].key;
      if (playedKeys[k]) continue;
      var url = getAudioUrl(k);
      if (!url) {
        playedKeys[k] = true;
        continue;
      }
      if (k === 'nutrition' && isLabelInfoHidden()) {
        playedKeys[k] = true;
        continue;
      }
      return false;
    }
    return true;
  }

  /** Sección cuyo bloque coincide con la línea focal del viewport (orden de página). */
  function getActiveCueIndex() {
    var centerY = window.innerHeight * 0.42;
    var i;
    var el;
    var r;
    for (i = 0; i < NARRATIVE_ORDER.length; i++) {
      el = document.getElementById(NARRATIVE_ORDER[i].elId);
      if (!el) continue;
      if (NARRATIVE_ORDER[i].key === 'nutrition' && el.hidden) continue;
      r = el.getBoundingClientRect();
      if (r.top <= centerY && r.bottom >= centerY) return i;
    }
    var best = -1;
    for (i = NARRATIVE_ORDER.length - 1; i >= 0; i--) {
      el = document.getElementById(NARRATIVE_ORDER[i].elId);
      if (!el) continue;
      if (NARRATIVE_ORDER[i].key === 'nutrition' && el.hidden) continue;
      r = el.getBoundingClientRect();
      if (r.top <= centerY) {
        best = i;
        break;
      }
    }
    return best;
  }

  function tryScrollNarration() {
    if (!audioEnabled || otraForma || userPausedScroll) return;
    if (audioPlayer && !audioPlayer.paused && !audioPlayer.ended) return;

    var idx = getActiveCueIndex();
    if (idx < 0) return;
    if (idx >= 3 && getAudioUrl('nutrition') && !playedKeys.nutrition && !isLabelInfoHidden()) {
      idx = 2;
    }
    var cue = NARRATIVE_ORDER[idx];
    if (!cue || playedKeys[cue.key]) return;
    if (!prerequisitesMetCueIndex(idx)) return;

    var url = getAudioUrl(cue.key);
    if (!url) {
      playedKeys[cue.key] = true;
      tryScrollNarration();
      return;
    }

    playAudio(url)
      .then(function () {
        playedKeys[cue.key] = true;
        updatePlaybackDock();
      })
      .catch(function () {});
  }

  function scheduleScrollNarration() {
    if (!audioEnabled || otraForma) return;
    if (scrollTickScheduled) return;
    scrollTickScheduled = true;
    requestAnimationFrame(function () {
      scrollTickScheduled = false;
      tryScrollNarration();
    });
  }

  function initScrollNarration() {
    window.addEventListener(
      'scroll',
      function () {
        scheduleScrollNarration();
      },
      { passive: true }
    );
    window.addEventListener('resize', scheduleScrollNarration);
    if (audioPlayer) {
      audioPlayer.addEventListener('ended', function () {
        updatePlaybackDock();
        tryScrollNarration();
      });
    }
  }

  function vibrate(ms) {
    if (otraForma) return;
    if (navigator.vibrate) navigator.vibrate(ms || 30);
  }


  function initAudioButtons() {
    document.querySelectorAll('.js-audio-toggle').forEach(function (btnToggle) {
      btnToggle.addEventListener('click', function () {
        if (audioEnabled) {
          setAudioEnabled(false);
        } else {
          resetNarrationState();
          setAudioEnabled(true);
          vibrate(80);
          var url = getAudioUrl('intro');
          if (url && !otraForma) {
            playAudio(url)
              .then(function () {
                playedKeys.intro = true;
                tryScrollNarration();
              })
              .catch(function () {});
          } else {
            tryScrollNarration();
          }
        }
      });
    });
  }

  function initQuickLinks() {
    var scrollBehavior = prefersReducedMotion() ? 'auto' : 'smooth';
    document.querySelectorAll('.mirada-quick-links a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
        }
      });
    });
  }

  function initNutritionToggle() {
    var btn = document.getElementById('btn-toggle-nutrition');
    var section = document.getElementById('label-info');
    if (!btn || !section) return;
    btn.addEventListener('click', function () {
      var hidden = section.hidden;
      section.hidden = !hidden;
      btn.setAttribute('aria-expanded', String(!hidden));
      btn.textContent = hidden ? 'Ocultar información de la etiqueta' : 'Ver información de la etiqueta';
      if (!hidden) section.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      setTimeout(scheduleScrollNarration, 400);
    });
  }

  function initForm() {
    var form = document.getElementById('form-miradas');
    var feedback = document.getElementById('form-miradas-feedback');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var selected = form.querySelector('input[name="mirada"]:checked');
      var textarea = form.querySelector('#tu-mirada');
      var mirada = selected ? selected.value : '';
      var tuMirada = textarea ? textarea.value.trim() : '';
      if (!mirada && !tuMirada) {
        if (feedback) {
          feedback.setAttribute('role', 'alert');
          feedback.textContent = 'Por favor, elige una opción o escribe tu mirada.';
          feedback.className = 'mirada-form-feedback mirada-form-feedback-error';
          form.querySelector('input[name="mirada"]')?.focus();
        }
        return;
      }
      if (feedback) {
        feedback.removeAttribute('role');
        feedback.setAttribute('role', 'status');
        feedback.textContent = '';
        feedback.className = 'mirada-form-feedback';
      }
      var endpoint = window.ALBINO_CONFIG?.miradasEndpoint;
      if (endpoint) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mirada: mirada, tu_mirada: tuMirada })
        }).then(function () {
          form.reset();
          if (feedback) {
            feedback.textContent = 'Gracias por compartir tu mirada.';
            feedback.className = 'mirada-form-feedback mirada-form-feedback-success';
          }
        }).catch(function () {
          if (feedback) {
            feedback.setAttribute('role', 'alert');
            feedback.textContent = 'No se pudo enviar. Inténtalo de nuevo.';
            feedback.className = 'mirada-form-feedback mirada-form-feedback-error';
          }
        });
      } else {
        form.reset();
        if (feedback) {
          feedback.textContent = 'Gracias por compartir tu mirada.';
          feedback.className = 'mirada-form-feedback mirada-form-feedback-success';
        }
      }
    });
  }

  function initReveal() {
    if (otraForma || prefersReducedMotion()) return;
    if (typeof IntersectionObserver === 'undefined') return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('reveal-in');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    initUmbral();
    initPlaybackDock();
    setAudioEnabled(false);
    initAudioButtons();
    initScrollNarration();
    initQuickLinks();
    initNutritionToggle();
    initForm();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
